import React from 'react';
import PropTypes from 'prop-types';
import ChevronIcon from '../chevron_icon';
import DetailsCell from './details_cell';
import InfoTooltip from '../info_tooltip';

const getStrokeClass = (point) => {
  if (point == null) return '';
  if (point <= -2) return 'eagle';
  if (point === -1) return 'birdie';
  if (point === 0) return 'par';
  if (point === 1) return 'bogey';
  return 'd-bogey';
};

const StrokeRow = ({ data, nrHoles, label, holeByHoleView, showYardage, onToggleYardage }) => (
  <tr className="lbv2__stroke-row">
    <DetailsCell className="lbv2__stroke text sticky">
      {onToggleYardage ? (
        <button className="lbv2__yardage-toggle-btn" onClick={onToggleYardage}>
          {label}
          <ChevronIcon isOpen={showYardage} />
        </button>
      ) : label}
    </DetailsCell>
    {data.strokesByHoleDisplay.map((strokes, index) => {
      // A hole without a displayed score gets no shape or color: a spec that
      // hides scores after N holes blanks the strokes but keeps points_by_hole
      // populated, which would otherwise draw empty circles and squares.
      const scoreClass = strokes ? getStrokeClass(data.pointsByHole?.[index]) : '';
      const viewClass = scoreClass ? ` ${holeByHoleView}` : '';
      return (
        <React.Fragment key={index}>
          <DetailsCell className={`lbv2__stroke${scoreClass ? ` ${scoreClass}` : ''}${viewClass}`}>
            <div className={`lbv2__stroke-shape${strokes && data.strikethroughsStrokesByHole?.[index] ? ' striked' : ''}`}>{strokes}</div>
          </DetailsCell>
          {index === 8 && nrHoles === 18 && <DetailsCell className="lbv2__stroke sum-front">{data.strokeSumFront}</DetailsCell>}
          {index === 17 && nrHoles === 18 && <DetailsCell className="lbv2__stroke sum-back">{data.strokeSumBack}</DetailsCell>}
          {index === (nrHoles - 1) && (
            <DetailsCell className="lbv2__stroke total">
              {data.strokeSum}
              <InfoTooltip content={data.dispositionCause} />
            </DetailsCell>
          )}
        </React.Fragment>
      );
    })}
  </tr>
);

StrokeRow.propTypes = {
  data: PropTypes.object.isRequired,
  nrHoles: PropTypes.number.isRequired,
  label: PropTypes.string,
  holeByHoleView: PropTypes.string,
  showYardage: PropTypes.bool,
  onToggleYardage: PropTypes.func,
};

export default StrokeRow;
